import React from "react";
import Text from "@amzn/meridian/text";

const OpsClockTab: React.FC = () => (
  <Text>OPS Clock settings coming soon.</Text>
);

export default OpsClockTab;
